<template>
  <FourElement />
  <div class="collection-container">
    <!-- <SearchForm /> -->
    <TableList v-if="isShow" />
    <!-- <div v-if="dataSource && dataSource.length > 0">
      <div class="fs14 lh30 fl" style="color: #999999;">
        {{
          `共 ${pagination.total} 条记录，第${pagination.pageNum} / ${~~(
            pagination.total / pagination.pageSize
          ) +
            (pagination.total % pagination.pageSize
              ? 1
              : pagination.total === 0
              ? 1
              : 0)}页`
        }}
      </div>
      <div
        style="display: flex; flex-direction: row; float: right; padding-bottom: 50px;"
      >
        <a-pagination
          v-if="pagination.pageSize"
          class="mr20"
          v-model:current="pagination.pageNum"
          :total="pagination.total"
          v-model:pageSize="pagination.pageSize"
          :showTotal="() => false"
          :showSizeChanger="false"
          @change="initList"
        />
        <a-select
          class="mr10"
          style="min-width: 80px;"
          v-model:value="pagination.pageSize"
          @change="initList"
          placeholder="条"
          :options="[
            { value: 10, label: 10 },
            { value: 20, label: 20 },
            { value: 30, label: 30 },
            { value: 40, label: 40 },
            { value: 50, label: 50 }
          ]"
        >
        </a-select>
        <div class="lh30 mr10">条/页</div>
        <div class="lh30 mr10">跳转至</div>
        <a-input-number
          class="mr10"
          style="width: 50px;"
          :value="pagination.pageNum"
          placeholder="页"
          :max="
            pagination.total <= pagination.pageSize
              ? 1
              : Math.ceil(pagination.total / pagination.pageSize)
          "
          :min="1"
          @change="watchPage"
        />
        <div class="lh30">页</div>
      </div>
    </div> -->
  </div>
  <Modal />
</template>
<script>
import { toRefs, reactive, provide, onMounted, watch } from 'vue'
import FourElement from './components/FourElement'
import TableList from './components/List'
import Modal from './components/Modal'
import { common_querySiteInfo_get } from '@/server/modules/3426.js'
import {
  add_pdp_ambience_config,
  edit_pdp_ambience,
  get_pdp_ambience_list
} from '@/server/modules/8295.js'
import { message } from 'ant-design-vue'
import { common_lang_get } from '@/server/modules/3426.js'

export default {
  components: {
    FourElement,
    TableList,
    Modal
  },
  setup() {
    const state = reactive({
      formState: {
        deleteFlag: 0, //默认0
        active: false,
        ambienceDesc: '',
        langs: []
      },
      isShow: true,
      disabled: false,
      defaultLang: null,
      langCode: null,
      langList: [],
      btnLoading: false,
      formRef: null,
      isEdit: false,
      visible: false,
      visibleChange: (visible = false) => {
        state.isEdit = false
        state.formState = {
          deleteFlag: 0, //默认0
          active: false,
          langs: []
        }
        if (visible) {
          state.formState.langs = state.langList.map(item => {
            const langCode = item.value
            return {
              langCode,
              ambienceDesc: ''
            }
          })
        }
        state.visible = visible
      },

      watchPage: e => {
        state.pagination.pageNum = e
        state.initList()
      },
      getAmbienceDescDefault() {
        const data = getLangData()
        return data.ambienceDesc
      },
      async handleSave() {
        let flag = true
        const { langs } = state.formState
        Array.isArray(langs) &&
          langs.map(item => {
            if (!item.ambienceDesc) {
              flag = false
            }
          })

        if (!flag) {
          message.warn('所有多语言展示文案必填!')
          return
        }
        try {
          await state.formRef.validate()
          if (state.isEdit) {
            state.handleEditData()
          } else {
            state.addConfigData()
          }
        } catch (error) {
          console.log('error', error)
        }
      },
      async addConfigData() {
        // debugger
        if (state.dataSource.length === 1) {
          message.warn('每个站点最多配置一条!')
          return false
        }
        const params = {
          ...state.formState,
          ...state.searchParams,
          ambienceDesc: state.getAmbienceDescDefault()
        }
        state.btnLoading = true
        let { success, retInfo } = await add_pdp_ambience_config(params)
        if (success) {
          state.visible = false
          state.btnLoading = false
          state.getDataList()
        } else {
          message.error(retInfo)
          state.btnLoading = false
        }
      },
      showEdit(record) {
        const { langs, id } = record
        id &&
          Array.isArray(langs) &&
          langs.map(item => {
            item.id = id
          })
        state.formState = { ...state.formState, ...record }
        state.setLangData()
        state.isEdit = true
        state.visible = true
      },
      async handleEditData() {
        const params = {
          ...state.formState,
          ...state.searchParams,
          ambienceDesc: state.getAmbienceDescDefault()
        }
        state.btnLoading = true
        let { success, data, retInfo } = await edit_pdp_ambience(params)
        if (success) {
          console.log('data', data)
          state.visible = false
          state.getDataList()
        } else {
          message.error(retInfo)
        }
        state.btnLoading = false
      },
      async getDataList() {
        const params = {
          ...state.searchParams
        }
        let { success, data } = await get_pdp_ambience_list(params)
        if (success) {
          state.dataSource = data
          // state.pagination.total = data.total
        }
      },

      value: null,
      dataSource: [],
      searchParams: {
        terminalId: 1,
        brandId: 1,
        channelId: 1,
        siteId: 1
      },
      brands: [],
      channels: [],
      sites: [],

      pagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },

      initList: async () => {
        await state.getLang()
        state.getDataList()
      }, // 初始化标题列表
      getLang: async function() {
        let params = { ...state.searchParams }
        const { success, data, retInfo } = await common_lang_get({
          ...params
        })
        if (success) {
          if (!data) {
            state.isShow = false
            return
          }
          const { languageMap } = data
          if (!languageMap) {
            state.isShow = false
            return
          }
          state.isShow = true
          let langList = []
          for (let [label, value] of Object.entries(languageMap || [])) {
            langList.push({ value, label })
          }
          if (langList) {
            state.langList = langList
            const langCode = langList[0].value
            state.langCode = langCode
            state.defaultLang = langCode
          }
        } else {
          message.error(retInfo)
        }
      },
      setLangData: () => {
        const data = getLangData()
        state.formState.ambienceDesc = data.ambienceDesc
      },
      handleLangChange: (langCode = '') => {
        state.langCode = langCode

        const disabled = state.defaultLang !== state.langCode
        if (state.disabled !== disabled) {
          state.disabled = disabled
        }
        state.setLangData()
      }
    })

    const common_querySiteInfo_get_ = async function({ state }, cb = () => {}) {
      const { success, data, retInfo } = await common_querySiteInfo_get()
      if (success) {
        for (let [key, items] of Object.entries(data)) {
          switch (key) {
            case '1':
              state.brands = items
              break
            case '2':
              state.channels = items
              break
            case '3':
              state.sites = items
              break
            case '4':
              state.terminals = items
              break
          }
        }
        cb()
      } else {
        message.error(retInfo)
      }
    }
    onMounted(() => {
      common_querySiteInfo_get_({
        state
      })
      state.initList()
    })

    const getLangData = () => {
      const data = state.formState.langs.find(
        item => item.langCode === state.langCode
      )
      return data
    }

    watch(
      () => state.formState.ambienceDesc,
      val => {
        if (!state.visible) {
          return
        }
        const data = getLangData()
        if (!data) {
          return
        }
        data.ambienceDesc = val
      }
    )
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
